'use client';
import { cx } from '@/lib/utils';
import React, { useEffect } from 'react';

type HamburgerProps = {
  isOpen?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const Hamburger = (props: HamburgerProps) => {
  const { isOpen, onClick } = props;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    // Cleanup function
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <button className={cx('z-10 block lg:hidden')} onClick={onClick} aria-label="Main Menu" aria-expanded={isOpen}>
      <svg width="40" height="40" viewBox="0 0 100 100">
        <path
          className="fill-none stroke-brand stroke-[6px]"
          d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
          strokeLinecap="round"
          strokeDasharray={isOpen ? '90 207' : '60 207'}
          strokeDashoffset={isOpen ? '-134' : '0'}
          style={{
            transition:
              'stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        />
        <path
          className="fill-none stroke-brand stroke-[6px]"
          d="M 20,50 H 80"
          strokeLinecap="round"
          strokeDasharray={isOpen ? '1 60' : '60 60'}
          strokeDashoffset={isOpen ? '-30' : '-95'}
          style={{
            transition:
              'stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        />
        <path
          className="fill-none stroke-brand stroke-[6px]"
          d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
          strokeLinecap="round"
          strokeDasharray={isOpen ? '90 207' : '60 207'}
          strokeDashoffset={isOpen ? '-134' : '45'}
          style={{
            transition:
              'stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        />
      </svg>
    </button>
  );
};
